import { createFileRoute, Link, Outlet, redirect, useNavigate } from "@tanstack/react-router";
import { LogOut } from "lucide-react";
import { toast } from "sonner";
import { BrandLogo } from "@/components/BrandLogo";
import { authRepository } from "@/data/repositories";

export const Route = createFileRoute("/portal")({
  ssr: false,
  beforeLoad: async () => {
    const viewer = await authRepository.getViewer();
    if (!viewer) throw redirect({ to: "/acceso" });
    if (!viewer.hasPortal && !viewer.isAdmin) throw redirect({ to: "/acceso" });
    return { viewer };
  },
  head: () => ({
    meta: [{ title: "Portal privado — SUSIEDAD" }, { name: "robots", content: "noindex,nofollow" }],
  }),
  component: PortalLayout,
});

function PortalLayout() {
  const navigate = useNavigate();
  async function signOut() {
    await authRepository.signOut();
    toast.success("Sesión cerrada");
    navigate({ to: "/acceso", replace: true });
  }
  return (
    <div className="min-h-screen bg-bone">
      <header className="sticky top-0 z-40 border-b border-border bg-bone/90 backdrop-blur-xl">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-5">
          <Link to="/portal" className="flex items-center gap-3">
            <BrandLogo variant="monogram" className="h-7 w-auto" />
            <div>
              <BrandLogo className="h-4 w-auto" />
              <p className="font-mono text-[8px] uppercase tracking-[0.2em] text-muted-foreground">
                Portal privado
              </p>
            </div>
          </Link>
          <button className="btn-quiet !min-h-9 !px-3" onClick={signOut}>
            <LogOut className="size-4" /> Salir
          </button>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-8 lg:py-12">
        <Outlet />
      </main>
    </div>
  );
}
